module.exports = __webpack_public_path__ + "static/valores-d90d250331ed1275622439339ff854b1.png";